/***********************************************************************
 This class represents a scorm API.
 An instance of this class wrappes an external SCORM api and call its functions
 depends on the SCORM version of the external LMS api.
 ***********************************************************************/
import {LoggingService} from "logging/LoggingService";
import {Assert} from "common/Assert";

export function ExternalScormApiWrapper( scormApi, expectedApi ) {

    Assert.checkArgument(scormApi);
    Assert.checkArgument(expectedApi);
    Assert.checkArgument(expectedApi.initialize);
    Assert.checkArgument(expectedApi.terminate);
    Assert.checkArgument(expectedApi.setValue);
    Assert.checkArgument(expectedApi.getValue);
    Assert.checkArgument(expectedApi.commit);
    Assert.checkArgument(expectedApi.getLastError);
    Assert.checkArgument(expectedApi.getErrorString);
    Assert.checkArgument(expectedApi.getDiagnostic);

    function callExternalApi( apiMethodName, parameter1, parameter2 ){

        let result;

        if( !apiMethodIsAvailable( apiMethodName ) ){
            return "false";
        }

        if( typeof(parameter2) === "string" ){
            result = scormApi[apiMethodName]( parameter1, parameter2 );
        }
        else if( parameter1 ){
            result = scormApi[apiMethodName]( parameter1 );
        }
        else {
            result = scormApi[apiMethodName]("");
        }

        if( result === "false" ){
            logLmsError( apiMethodName, parameter1, parameter2 );
        }

        return result;
    }

    function apiMethodIsAvailable( apiMethodName ){

        if( typeof( scormApi[apiMethodName] ) !== "undefined" ){
            return true;
        }

        LoggingService.error( "Api method " + apiMethodName + " is undefined on lms api!");
        return false;
    }

    function getLastError(){
        return scormApi[expectedApi.getLastError]();
    }

    function getErrorString( errorCode ) {
        return scormApi[expectedApi.getErrorString]( errorCode );
    }

    function logLmsError( apiMethodName, parameter1, parameter2 ){

        let msg = "Error on " + apiMethodName;

        if( parameter1 ){
            msg = msg + "\nparam1: " + parameter1;
        }

        if( parameter2 ){
            msg = msg + "\nparam2: " + parameter2;
        }

        const errorCode = getLastError() + "";
        if( errorCode && errorCode !== "0" ) {
            msg = msg + "\nLMS error message: " + getErrorString(errorCode);
        }

        LoggingService.error(msg);
    }

    // revealing public api
    return {
        initialize: () => {
            return callExternalApi(expectedApi.initialize);
        },
        terminate: () => {
            return callExternalApi(expectedApi.terminate);
        },
        getValue: (key) => {
            return callExternalApi(expectedApi.getValue, key);
        },
        setValue: (key, value) => {
            return callExternalApi(expectedApi.setValue, key, value);
        },
        commit: () => {
            return callExternalApi(expectedApi.commit);
        },
        getLastError: () => {
            return callExternalApi(expectedApi.getLastError);
        },
        getErrorString: (errorCode) => {
            return callExternalApi(expectedApi.getErrorString, errorCode);
        },
        getDiagnostic: (parameter) => {
            return callExternalApi(expectedApi.getDiagnostic, parameter);
        }
    };
}
